import React, { useState } from "react";
import { LinkButton } from "../framework/common/linkButton";
import { useTranslation } from "react-i18next";
import { useAppDispatch, useAppSelector } from "../framework/redux/hooks";
import Grid2 from "@mui/material/Unstable_Grid2";
import { LoadingButton } from "../components/framework/loadingButton";
import { finishWorkTime, saveWorkTimeLocation } from "../services/workShiftTimeSlotService";
import { handleApiError } from "../services/baseService";
import { IWorkShiftTimeSlot } from "../models/workShiftTimeSlot/workShiftTimeSlot";
import { getGeolocationPosition } from "../framework/common/geolocation";
import { workTimeGeolocationPositionErrorDuration } from "../components/worktime/workTimeTypeDrawer";
import { AlertSeverity } from "../models/common/enums";
import { fetchCurrentWorkShift } from "../framework/redux/slices/workShiftSlice";
import { useWorkTimeDefaultTimezone } from "../hooks/framework/useWorkTimeDefaultTimezone";

export interface IMainButtonsProps {
    current: IWorkShiftTimeSlot;
}

export const MainButtons = ({ current }: IMainButtonsProps) => {
    const [submitting, setSubmitting] = useState<boolean>(false);
    const [defaultTz] = useWorkTimeDefaultTimezone();

    const usesLocationData = useAppSelector(
        ({ session }) => session.employeeGroupParameters?.usesLocationData
    );

    const { t } = useTranslation();
    const dispatch = useAppDispatch();

    const handleFinish = async () => {
        setSubmitting(true);

        const finishResult = await finishWorkTime({
            timezoneName: defaultTz,
        }).catch(handleApiError);

        if (finishResult && finishResult.id && usesLocationData) {
            getGeolocationPosition({
                message: t("workTime.geolocationPositionError"),
                severity: AlertSeverity.Warning,
                duration: workTimeGeolocationPositionErrorDuration,
            }).then(location =>
            {
                if (!!location)
                    return saveWorkTimeLocation(
                        finishResult.id,
                        location,
                        "finish"
                    );
            }
            ).catch(console.error);
        }

        await dispatch(fetchCurrentWorkShift());
        setSubmitting(false);
    };

    return (
        <Grid2 container spacing={2} mt={2} alignItems="stretch">
            {!current ? null : (
                <Grid2 xs={6}>
                    <LoadingButton
                        style={{ height: "100%" }}
                        color="error"
                        variant="contained"
                        loading={submitting}
                        onClick={() => void handleFinish()}
                    >
                        {t("workTime.finishWork")}
                    </LoadingButton>
                </Grid2>
            )}
            <Grid2 xs={!current ? 12 : 6}>
                <LinkButton
                    style={{ height: "100%" }}
                    color="success"
                    variant="contained"
                    to="/work/start"
                >
                    {!current
                        ? t("workTime.startWork")
                        : t("workTime.changeTask")}
                </LinkButton>
            </Grid2>
        </Grid2>
    );
};
